import React from 'react';
import { Typography } from "@material-ui/core";
import { Parallax } from 'react-scroll-parallax';
import AppearingElement from '../Helper/AppearingElement';
import './main.css';

// Landing Pages Section 2A
function MountainInfoSection(props) {
    return (
        <section className="mountain-info-section">
            <div className="mountain-info-section__content">
                {!props.hideParallax &&
                    <Parallax y={[-25, 10]}>
                        <AppearingElement variant="fade-in">
                            <Typography variant="h5">
                                {props.content}
                            </Typography>
                        </AppearingElement>
                    </Parallax>
                }
                {props.hideParallax &&
                    <AppearingElement variant="zoom-down">
                        <Typography variant="h5">
                            {props.content}
                        </Typography>
                    </AppearingElement>
                }
            </div>
            {!props.hideParallax &&
                <Parallax y={[25, -15]} className="mountain-info-section__media">
                    <AppearingElement variant="fade-in" threshold="0.2">
                        <video src={props.media} autoPlay loop muted playsInline>
                            Sorry, your browser doesn't support embedded videos.
                    </video>
                    </AppearingElement>
                </Parallax>
            }
            {props.hideParallax &&
                <video src={props.media} className="mountain-info-section__media" autoPlay loop muted playsInline>
                    Sorry, your browser doesn't support embedded videos.
            </video>
            }
        </section>
    );
}

export default MountainInfoSection;